'use client';

import type { PropsWithChildren } from 'react';

import { IoBook, IoBookOutline } from 'react-icons/io5';

import type { BaseComponentProps } from '../../../base-component.types';
import { IconButton } from '../../../icon-button';
import { AuditLogButton } from '../../layout/AuditLogButton';
import { InfoBar } from '../../layout/InfoBar';
import { TipIcon } from '../../layout/InfoIcons';
import type { MultipleChoiceQuestionAnswerType } from '../MultipleChoiceQuestionAnswer.types';
import { AnswerRate } from './AnswerRate';

type AnswerFooterProps = BaseComponentProps & {
  question: MultipleChoiceQuestionAnswerType;
  showReason?: boolean;
  onShowReason?: () => void;
};

function AnswerFooter({
  style,
  className,
  question,
  showReason = false,
  children,
  onShowReason,
}: PropsWithChildren<AnswerFooterProps>) {
  const { answerRate } = question;

  return (
    <InfoBar
      style={style}
      className={className}
      difficulty={question.difficulty}
      difficultyDetails={answerRate && <AnswerRate {...answerRate} />}
      options={
        <>
          {onShowReason && !!question.reason && (
            <IconButton
              icon={<IoBookOutline />}
              flipped={showReason}
              flipIcon={<IoBook />}
              aria-label={
                showReason ? 'Ocultar justificación' : 'Ver justificación'
              }
              onClick={onShowReason}
            />
          )}
          {question.tip && <TipIcon>{question.tip}</TipIcon>}
          {question.auditLog && question.auditLog.length > 0 && (
            <AuditLogButton auditLog={question.auditLog} />
          )}
        </>
      }
    >
      {children}
    </InfoBar>
  );
}

export { AnswerFooter };
